module.exports = __webpack_public_path__ + "static/ting-min.432f05c4.JPG";